import { DataLayer, FormLayerObject, PageLayerObject, AcquisitionLayerObject } from '@models/DataLayer.model';
import { Helpers } from './helpers';
declare const window: any;

export enum TrackType {
  PAGE_LOAD = "track_page_load",
  FORM_COMPLETE = "track_form_complete",
  FORM_ERORR = "track_form_error",
}

export class GAAviva {
  public digitalData: DataLayer = new DataLayer({});

  private static instance: GAAviva;
  private failed: any;
  private constructor(initial: any) {
    if (initial) {
      this.digitalData = new DataLayer(JSON.parse(initial));
    } else {
      const page = new PageLayerObject({});
      const form = new FormLayerObject({});
      const acquisition = new AcquisitionLayerObject({});
      this.digitalData = new DataLayer({ acquisition, page, form });
    }
  }

  public static getInstance(): GAAviva {
      if (!GAAviva.instance) {
        const now = new Date().getTime();
        const initial = sessionStorage.getItem('aviva_ga_cached');
        const persisExpiredTime = sessionStorage.getItem('persist:expired') || 0;
        if (now > Number(persisExpiredTime) || !persisExpiredTime) {
          GAAviva.instance = new GAAviva(null);
        } else {
          GAAviva.instance = new GAAviva(initial);
        }
        
      }
      return GAAviva.instance;
      
  }

  public trackFormSuccess(data: object): void {
    Object.assign(this.digitalData, data);
    const type = TrackType.FORM_COMPLETE;
    if (window._satellite) {
      try {
        window._satellite.track(type);
        window.digitalData = this.digitalData;
        this.failed = null;
        console.debug({ type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      } catch (e) {
        this.retry(() => this.trackFormSuccess(data));
      }
    } else {
      console.error('AA script not loaded', { type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      this.retry(() => this.trackFormSuccess(data));
    }
    console.debug({ type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
    sessionStorage.setItem('aviva_ga_cached', JSON.stringify(this.digitalData));

  }

  public trackFormFailed(data: object): void {
    Object.assign(this.digitalData, data);
    const type = TrackType.FORM_ERORR;
    if (window._satellite) {
      try {
        window._satellite.track(type);
        this.failed = null;
        window.digitalData = this.digitalData;
        console.debug({ type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      } catch (e) {
        this.failed = type;
        this.retry(() => { this.recallFailed(); });
      }
    } else {
      console.debug('AA script not loaded', { type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      this.retry(() => { this.recallFailed(); });
    }
    sessionStorage.setItem('aviva_ga_cached', JSON.stringify(this.digitalData));

  }

  public trackPageLoad(data: object): void {
    const navs = Helpers.getNavLevels();
    Object.assign(this.digitalData, data);
    const { page } = this.digitalData;
    Object.assign(this.digitalData, { page: { ...page, ...navs } });
    const type = TrackType.PAGE_LOAD;
    if (window._satellite) {
      try {
        window._satellite.track(type);
        window.digitalData = this.digitalData;
        this.failed = null;
        console.debug({ type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      } catch (e) {
        this.retry(() => this.trackPageLoad(data));
      }
    } else {
      this.failed = type;
      console.debug('AA script not loaded', { type: type, digitalData: this.digitalData, form: this.digitalData.form.name });
      this.retry(() => this.trackPageLoad(data));
    }
    sessionStorage.setItem('aviva_ga_cached', JSON.stringify(this.digitalData));
  }

  public retry(callback: any) {
    setTimeout(callback , 10000);
  }

  public recallFailed(): void {
    if (this.failed && window._satellite) {
      window._satellite.track(this.failed);
      window.digitalData = this.digitalData;
      console.debug('Recall', { type: this.failed, digitalData: this.digitalData, form: this.digitalData.form.name });
      this.failed = null;
    }
  }
}